export default __webpack_public_path__ + "static/media/EAST1070.34I-34201_-18447_0.70ed06b5.jpg";